import { useRef } from 'react';
import { isLocalLibraryRoute } from '../lib/libraryViewRetention';
import { isHomeAppRoute } from '../utils/homeRoute';

export function useAppSectionRetention(pathname) {
  const isLibraryRoute = isLocalLibraryRoute(pathname);
  const librarySectionCachedRef = useRef(isLibraryRoute);
  if (isLibraryRoute) librarySectionCachedRef.current = true;

  const isHomeRoute = isHomeAppRoute(pathname);
  const homeSectionCachedRef = useRef(isHomeRoute);
  if (isHomeRoute) homeSectionCachedRef.current = true;

  return {
    isLibraryRoute,
    librarySectionCached: librarySectionCachedRef.current,
    isHomeRoute,
    homeSectionCached: homeSectionCachedRef.current,
  };
}
